import { z } from 'zod/v3';

import { sortingDirectionSchema } from 'features/procurement/schema';

import { AssignInvoiceState, InvoicesRequestParams, InvoicesSorting } from '../api-types';

export const invoicesFiltersSchema = z.object({
  statuses: z.custom<InvoicesRequestParams['statuses']>().optional(),
  vendorCodes: z.custom<InvoicesRequestParams['vendorCodes']>().optional(),
  venueCodes: z.custom<InvoicesRequestParams['venueCodes']>().optional(),
  assigneeIds: z.array(z.string()).optional(),
  assignState: z.custom<AssignInvoiceState>().optional(),
  countryCodes: z.custom<InvoicesRequestParams['countryCodes']>().optional(),
  earliestInvoiceDate: z.string().optional(),
  latestInvoiceDate: z.string().optional(),
  earliestReceivedAt: z.string().optional(),
  latestReceivedAt: z.string().optional(),
  earliestPaymentDueDate: z.string().optional(),
  latestPaymentDueDate: z.string().optional(),
  sources: z.custom<InvoicesRequestParams['sources']>().optional(),
});

export const invoicesSearchParamsSchema = z.object({
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  q: z.coerce.string().optional(),
  sortBy: z.custom<InvoicesSorting>().optional(),
  sortingType: sortingDirectionSchema.optional(),
});

const invoicesModalsSchema = z.object({
  updateId: z.string().optional(),
  vendorCodeForUpdate: z.string().optional(),
  venueIdForUpdate: z.string().optional(),
  changeToNegativeModalOpen: z.boolean().optional(),
});

export const inventoryInvoicesRouteSearchSchema = z.object({
  ...invoicesFiltersSchema.shape,
  ...invoicesSearchParamsSchema.shape,
  ...invoicesModalsSchema.shape,
});

export type InvoicesFilters = z.infer<typeof invoicesFiltersSchema>;
export type InvoicesModals = z.infer<typeof invoicesModalsSchema>;
